import PropTypes from "prop-types";
import { Box, Container, Typography } from "@mui/material";

// Placeholder for platforms that are not yet supported (e.g. "android").
export function ComingSoonPage(props) {
  const { appName, platform } = props;
  return (
    <Container maxWidth="xl" sx={{ marginTop: 3 }}>
      <Box mt={6} display="flex" justifyContent="center">
        <Typography align="center">
          The <strong>{platform}</strong> version of{" "}
          <strong>"{appName}"</strong> app is coming soon.
        </Typography>
      </Box>
    </Container>
  );
}

ComingSoonPage.propTypes = {
  appName: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
};
